/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Forside_Redact_Name_LabelInputs */

const da_forside_redact_name_label = /** @type {(inputs: Forside_Redact_Name_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Navn:`)
};

/** @type {(inputs: Forside_Redact_Name_LabelInputs) => LocalizedString} */
const en_forside_redact_name_label = da_forside_redact_name_label;

/**

* @param {Forside_Redact_Name_LabelInputs} inputs
* @param {{ locale?: "da" | "en" }} options
* @returns {LocalizedString}
*/
export const forside_redact_name_label = /** @type {((inputs?: Forside_Redact_Name_LabelInputs, options?: { locale?: "da" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Forside_Redact_Name_LabelInputs, { locale?: "da" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_forside_redact_name_label(inputs)
	return /** @type {LocalizedString} */ ("Navn:")
});